import React, { useMemo } from 'react';
import { Modal } from '../Modal';
import { useStatus } from '../../contexts/StatusContext';
import * as S from './Styled';

interface ClosedModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const ClosedModal: React.FC<ClosedModalProps> = ({ isOpen, onClose }) => {
  const { status } = useStatus();

  const { message, subtitle } = useMemo(() => {
    if (!status || status.isOpen) {
      return { message: '', subtitle: '' };
    }

    let msg = 'No momento estamos fechados.';
    let sub = '';

    if (status.nextOpen) {
      sub = `Abriremos ${status.nextOpen.day} às ${status.nextOpen.time}`;
    }

    if (status.manualOverride?.reason) {
      msg = status.manualOverride.reason;
    }

    return { message: msg, subtitle: sub };
  }, [status]);

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <S.Container>
        <S.IconContainer>
          <S.Icon>🔒</S.Icon>
        </S.IconContainer>
        
        <S.Title>Estamos Fechados</S.Title>
        
        <S.Message>{message}</S.Message>
        
        {subtitle && <S.Subtitle>{subtitle}</S.Subtitle>}
        
        <S.CloseButton onClick={onClose}>
          Entendi
        </S.CloseButton>
      </S.Container>
    </Modal>
  );
};
